import { parseHoursQuantity } from './hourQuantity';

interface QuantityAndUnit {
    quantity: number | null;
    unit: string | null;
}

export const parseQuantityAndUnit = (input: string): QuantityAndUnit => {
    // Delete spaces
    const trimmedInput = input.trim()

    // Check for percentage
    if (trimmedInput.endsWith('%')) {
        const percentage = parseFloat(trimmedInput.slice(0, -1).replace(',', '.'));
        if (!isNaN(percentage)) {
            return { quantity: percentage / 100, unit: '%' }
        }
    }

    // Check for an hours notation like 0:31 uur, the quantity becomes a decimal number of hours
    const hoursMatch = trimmedInput.match(/^(-?\d+:\d{1,2})\s*(\D*)$/);
    if (hoursMatch) {
        const hours = parseHoursQuantity(hoursMatch[1]);
        if (hours !== null) {
            return { quantity: hours, unit: hoursMatch[2] ? hoursMatch[2].trim() : null };
        }
    }

    // Split based on first non numeric character after a series of numbers
    const match = trimmedInput.match(/^(-?\d+[\.,]?\d*)\s*(\D*)$/);

    if (match) {
        let quantity = match[1].replace(',', '.');
        let unit = match[2] ? match[2].trim() : null;
        return { quantity: parseFloat(quantity), unit };
    }

    return { quantity: null, unit: null };
}